import React from 'react'

const Back = ({ className }: { className?: string }) => {
    return (
        <svg className={className} fill="none" height="26" viewBox="0 0 26 26" width="26" xmlns="http://www.w3.org/2000/svg">
<path d="M21.6667 13.8125C21.8822 13.8125 22.0888 13.7269 22.2412 13.5745C22.3936 13.4222 22.4792 13.2155 22.4792 13C22.4792 12.7845 22.3936 12.5778 22.2412 12.4255C22.0888 12.2731 21.8822 12.1875 21.6667 12.1875V13.8125ZM21.6667 12.1875L4.33335 12.1875V13.8125L21.6667 13.8125V12.1875Z" fill="currentColor" opacity="0.5"></path>
<path d="M10.8334 19.5L4.33337 13L10.8334 6.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.625"></path>
</svg>
    )
}

export default Back
